import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import coursesData from "../data/courses.json";
import "../styles/coursestyle.css";

const API = "https://techsphere-backend-production.up.railway.app";

function Courses() {
  const [filter, setFilter] = useState("all");
  const [modal, setModal] = useState(null);
  const [courses, setCourses] = useState(coursesData);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API}/api/courses`)
      .then((r) => r.json())
      .then((data) => {
        if (data.length > 0) setCourses(data);
      })
      .catch(() => {});
  }, []);

  const filtered =
    filter === "all" ? courses : courses.filter((c) => c.category === filter);

  const handleEnroll = async () => {
    if (!name || !email) {
      setMsg("❌ Please fill all fields!");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          email,
          course: modal,
          message: "Enrolled from courses page",
        }),
      });
      const data = await res.json();
      if (data.message) {
        setMsg("✅ Enrolled successfully!");
        setTimeout(() => {
          setModal(null);
          setMsg("");
          setName("");
          setEmail("");
        }, 2000);
      } else {
        setMsg("❌ " + (data.error || "Error!"));
      }
    } catch {
      setMsg("❌ Server error!");
    }
    setLoading(false);
  };

  return (
    <>
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="badge">Next-Gen Learning</span>
          <h1>
            Explore Our <span>Courses</span>
          </h1>
          <p>Master in-demand skills with our industry-led expert courses.</p>
          <div className="hero-stats">
            <div className="stat-item">
              <b>8+</b>Courses
            </div>
            <div className="stat-item">
              <b>100%</b>Online
            </div>
          </div>
        </div>
      </section>

      <div className="filter-section">
        {["all", "dev", "design"].map((cat) => (
          <button
            key={cat}
            className={`filter-btn ${filter === cat ? "active" : ""}`}
            onClick={() => setFilter(cat)}
          >
            {cat === "all" ? "All" : cat === "dev" ? "Development" : "Design"}
          </button>
        ))}
      </div>

      <section className="courses">
        <div className="cards-container">
          {filtered.map((course) => (
            <div className="card-item" key={course.id}>
              <div className="card">
                <img src={course.img} alt={course.title} />
                <h3>{course.title}</h3>
                <p>{course.desc || course.description}</p>
                <button
                  className="enroll-btn"
                  onClick={() => {
                    setModal(course.title);
                    setMsg("");
                  }}
                >
                  Enroll Now →
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {modal && (
        <div
          className="modal"
          style={{ display: "block" }}
          onClick={() => setModal(null)}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={() => setModal(null)}>
              &times;
            </span>
            <h2>Enroll in {modal}</h2>
            <p>Fill your details to enroll in this course!</p>
            <input
              type="text"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              className="submit-btn"
              onClick={handleEnroll}
              disabled={loading}
            >
              {loading ? "Enrolling..." : "Confirm Enrollment →"}
            </button>
            {msg && (
              <p
                style={{
                  marginTop: "12px",
                  fontSize: "14px",
                  color: msg.includes("✅") ? "green" : "red",
                }}
              >
                {msg}
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
}
export default Courses;
